import { useNavigate } from 'react-router-dom';
import { Button } from '@clarix/ui';
import { useAuthStore } from '@clarix/auth-store';
import { useLogout } from '@/core/api';

/**
 * Account switcher for an already-authenticated user — reached ONLY via an
 * explicit `/login?switch=1`.
 *
 * A plain `/login` visit while signed in no longer stops here: RequireUnauthed
 * forwards straight to the workspace, because making every arrival click
 * "Continue" bought the user nothing (and, while the backend was down, pointed
 * at a workspace that couldn't load). This screen exists purely for the one
 * intent the redirect can't serve: signing in as someone else.
 */
export function AlreadySignedIn() {
  const navigate = useNavigate();
  const email = useAuthStore((s) => s.user?.email);
  const workspaceSlug = useAuthStore((s) => s.workspaceSlug);
  const logout = useLogout();

  return (
    <div>
      <h1 className="mb-1 text-5xl font-semibold text-slate-900 dark:text-slate-100">
        You&apos;re already signed in
      </h1>
      <p className="mb-6 text-xl text-slate-500">
        {email ? (
          <>
            Signed in as{' '}
            <span className="font-medium text-slate-700 dark:text-slate-300">{email}</span>.
          </>
        ) : (
          'You already have an active session.'
        )}
      </p>

      <div className="space-y-3">
        <Button
          className="w-full"
          onClick={() => navigate(workspaceSlug ? '/' : '/onboarding', { replace: true })}
        >
          Continue to your workspace
        </Button>
        <Button
          variant="outline"
          className="w-full"
          disabled={logout.isPending}
          onClick={() => logout.mutate()}
        >
          {logout.isPending ? 'Signing out…' : 'Use another account'}
        </Button>
      </div>
    </div>
  );
}
